<template>
  <div class="suggested shadow-s">
    <div class="title-bloc">
      {{ $t('shared.suggestedCommunities.joinNewCommunities') }}
    </div>
    <div class="community"
         v-for="suggestedCommunity in communities"
         :key="suggestedCommunity.id"
         @click="linkCommunity(suggestedCommunity.id)"
    >
      <v-image :image-id="suggestedCommunity.idImage"
               default="DefaultCommunityVisual.png"
      />
      <div class="name link hover-effect">
        {{ communityName(suggestedCommunity.name) }}
      </div>
    </div>
  </div>
</template>

<script>
import VImage from './VImage'

export default {
  name: 'SuggestedCommunities',
  components: { VImage },
  props: {
    communities: {
      type: Array,
      required: true
    }
  },
  methods: {
    linkCommunity(id) {
      this.$router.push({ name: 'communityPage', params: { id: id } })
    },
    communityName(name) {
      return name.length > 30 ? name.substring(0, 30).concat('...') : name
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.suggested {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  max-width: 220px;
  @media (max-width: $header-change) {
    max-width: none;
    width: 100%;
    background-color: white;
  }
  .title-bloc {
    margin: 1rem;
  }

  .community {
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0 0.5rem 1.2rem;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    cursor: pointer;
    width: 16.2rem;

    img {
      max-width: 20%;
      object-fit: cover;
      object-position: 20% 20%;
    }

    .name {
      margin-left: 0.8rem;
      max-width: 115px;
      width: 80%;
      word-wrap: break-word;
    }
  }
}
</style>
